var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrinter = function SvgPrinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411,243h-2v-2a5,5,0,0,0-5-5h-8a5,5,0,0,0-5,5v2h-2a5,5,0,0,0-5,5v7a5,5,0,0,0,5,5h2v5a3,3,0,0,0,3,3h12a3,3,0,0,0,3-3v-5h2a5,5,0,0,0,5-5v-7A5,5,0,0,0,411,243Zm-18-2a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v2H393Zm14,24a1,1,0,0,1-1,1H394a1,1,0,0,1-1-1v-9h14Zm7-10a3,3,0,0,1-3,3h-2v-2h2a1,1,0,0,0,0-2H389a1,1,0,0,0,0,2h2v2h-2a3,3,0,0,1-3-3v-7a3,3,0,0,1,3-3h22a3,3,0,0,1,3,3Zm-19,4a1,1,0,0,1,1-1h8a1,1,0,0,1,0,2h-8A1,1,0,0,1,395,259Zm0,4a1,1,0,0,1,1-1h4a1,1,0,0,1,0,2h-4A1,1,0,0,1,395,263Zm17-15a1,1,0,0,1-1,1h-2a1,1,0,0,1,0-2h2A1,1,0,0,1,412,248Z",
    transform: "translate(-376 -228)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printer.cdf022ff.svg";
export { ForwardRef as ReactComponent };